import { logger } from '@/utils/eventLogger'

let storesReset: Promise<void> | null = null
let logoutCleanup: Promise<void> | null = null

/** A restored login must not start a client while the previous cleanup is still importing stores. */
export function waitForMatrixChatStoreReset(): Promise<void> {
  return logoutCleanup ?? storesReset ?? Promise.resolve()
}

/** Reset the shared runtime and view regardless of the currently open portal page. */
export function resetMatrixChatStores(): Promise<void> {
  if (storesReset) {
    return storesReset
  }

  storesReset = (async () => {
    const results = await Promise.allSettled([
      import('@/modules/chat-matrix-fast/stores/chatStore')
        .then(({ useChatStore }) => useChatStore().resetInitialization()),
      import('@/modules/chat-matrix-fast/stores/chatViewStore')
        .then(({ useChatStore }) => useChatStore().$reset()),
    ])

    for (const result of results) {
      if (result.status === 'rejected') {
        logger.warn('[Auth] Ошибка сброса Matrix chat store:', result.reason)
      }
    }
  })().finally(() => {
    storesReset = null
  })

  return storesReset
}

export function clearMatrixChatsOnLogout(): Promise<void> {
  if (logoutCleanup) {
    return logoutCleanup
  }

  logoutCleanup = (async () => {
    await resetMatrixChatStores()

    const results = await Promise.allSettled([
      import('@/modules/chat-matrix-fast/matrixAuth').then(({ resetMatrixSession }) => resetMatrixSession()),
    ])

    for (const result of results) {
      if (result.status === 'rejected') {
        logger.warn('[Auth] Ошибка очистки Matrix-сессии при logout:', result.reason)
      }
    }
  })().finally(() => {
    logoutCleanup = null
  })

  return logoutCleanup
}
